"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IamPermissions = void 0;
var IamPermissions;
(function (IamPermissions) {
    IamPermissions["ORGANIZATION_CREATE"] = "organization.create";
    IamPermissions["ORGANIZATION_READ"] = "organization.read";
    IamPermissions["ORGANIZATION_UPDATE"] = "organization.update";
    IamPermissions["ORGANIZATION_DELETE"] = "organization.delete";
    IamPermissions["ORGANIZATION_LIST"] = "organization.list";
    IamPermissions["ORGANIZATION_WRITE"] = "organization.write";
    IamPermissions["EVENT_CREATE"] = "event.create";
    IamPermissions["EVENT_READ"] = "event.read";
    IamPermissions["EVENT_UPDATE"] = "event.update";
    IamPermissions["EVENT_DELETE"] = "event.delete";
    IamPermissions["EVENT_LIST"] = "event.list";
    IamPermissions["EVENT_WRITE"] = "event.write";
    IamPermissions["ORDER_CREATE"] = "order.create";
    IamPermissions["ORDER_READ"] = "order.read";
    IamPermissions["ORDER_UPDATE"] = "order.update";
    IamPermissions["ORDER_DELETE"] = "order.delete";
    IamPermissions["ORDER_LIST"] = "order.list";
    IamPermissions["ORDER_REFUND"] = "order.refund";
    IamPermissions["ORDER_WRITE"] = "order.write";
    IamPermissions["DEVICE_CREATE"] = "device.create";
    IamPermissions["DEVICE_READ"] = "device.read";
    IamPermissions["DEVICE_UPDATE"] = "device.update";
    IamPermissions["DEVICE_DELETE"] = "device.delete";
    IamPermissions["DEVICE_LIST"] = "device.list";
    IamPermissions["DEVICE_WRITE"] = "device.write";
    IamPermissions["CUSTOMER_CREATE"] = "customer.create";
    IamPermissions["CUSTOMER_READ"] = "customer.read";
    IamPermissions["CUSTOMER_UPDATE"] = "customer.update";
    IamPermissions["CUSTOMER_DELETE"] = "customer.delete";
    IamPermissions["CUSTOMER_LIST"] = "customer.list";
    IamPermissions["USER_CREATE"] = "user.create";
    IamPermissions["USER_READ"] = "user.read";
    IamPermissions["USER_UPDATE"] = "user.update";
    IamPermissions["USER_DELETE"] = "user.delete";
    IamPermissions["USER_LIST"] = "user.list";
    IamPermissions["USER_WRITE"] = "user.write";
    IamPermissions["SALES_REP_CREATE"] = "salesRep.create";
    IamPermissions["SALES_REP_READ"] = "salesRep.read";
    IamPermissions["SALES_REP_UPDATE"] = "salesRep.update";
    IamPermissions["SALES_REP_DELETE"] = "salesRep.delete";
    IamPermissions["SALES_REP_LIST"] = "salesRep.list";
    IamPermissions["PRIZE_CREATE"] = "prize.create";
    IamPermissions["PRIZE_READ"] = "prize.read";
    IamPermissions["PRIZE_UPDATE"] = "prize.update";
    IamPermissions["PRIZE_DELETE"] = "prize.delete";
    IamPermissions["PRIZE_LIST"] = "prize.list";
    IamPermissions["EVENT_COPY"] = "event.copy";
    IamPermissions["EVENT_ACTIVATE"] = "event.activate";
    IamPermissions["EVENT_MEMBER_CREATE"] = "eventMember.create";
    IamPermissions["EVENT_MEMBER_READ"] = "eventMember.read";
    IamPermissions["EVENT_MEMBER_UPDATE"] = "eventMember.update";
    IamPermissions["EVENT_MEMBER_DELETE"] = "eventMember.delete";
    IamPermissions["EVENT_MEMBER_LIST"] = "eventMember.list";
    IamPermissions["EVENT_MEMBER_UPLOAD"] = "eventMember.upload";
    IamPermissions["EVENT_SALES_REPORT"] = "reports.eventSales";
})(IamPermissions = exports.IamPermissions || (exports.IamPermissions = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaWFtLXBlcm1pc3Npb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21vZGVscy9pYW0tcGVybWlzc2lvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxjQWtFWDtBQWxFRCxXQUFZLGNBQWM7SUFDeEIsNkRBQTJDLENBQUE7SUFDM0MseURBQXVDLENBQUE7SUFDdkMsNkRBQTJDLENBQUE7SUFDM0MsNkRBQTJDLENBQUE7SUFDM0MseURBQXVDLENBQUE7SUFDdkMsMkRBQXlDLENBQUE7SUFFekMsK0NBQTZCLENBQUE7SUFDN0IsMkNBQXlCLENBQUE7SUFDekIsK0NBQTZCLENBQUE7SUFDN0IsK0NBQTZCLENBQUE7SUFDN0IsMkNBQXlCLENBQUE7SUFDekIsNkNBQTJCLENBQUE7SUFFM0IsK0NBQTZCLENBQUE7SUFDN0IsMkNBQXlCLENBQUE7SUFDekIsK0NBQTZCLENBQUE7SUFDN0IsK0NBQTZCLENBQUE7SUFDN0IsMkNBQXlCLENBQUE7SUFDekIsK0NBQTZCLENBQUE7SUFDN0IsNkNBQTJCLENBQUE7SUFFM0IsaURBQStCLENBQUE7SUFDL0IsNkNBQTJCLENBQUE7SUFDM0IsaURBQStCLENBQUE7SUFDL0IsaURBQStCLENBQUE7SUFDL0IsNkNBQTJCLENBQUE7SUFDM0IsK0NBQTZCLENBQUE7SUFFN0IscURBQW1DLENBQUE7SUFDbkMsaURBQStCLENBQUE7SUFDL0IscURBQW1DLENBQUE7SUFDbkMscURBQW1DLENBQUE7SUFDbkMsaURBQStCLENBQUE7SUFFL0IsNkNBQTJCLENBQUE7SUFDM0IseUNBQXVCLENBQUE7SUFDdkIsNkNBQTJCLENBQUE7SUFDM0IsNkNBQTJCLENBQUE7SUFDM0IseUNBQXVCLENBQUE7SUFDdkIsMkNBQXlCLENBQUE7SUFFekIsc0RBQW9DLENBQUE7SUFDcEMsa0RBQWdDLENBQUE7SUFDaEMsc0RBQW9DLENBQUE7SUFDcEMsc0RBQW9DLENBQUE7SUFDcEMsa0RBQWdDLENBQUE7SUFFaEMsK0NBQTZCLENBQUE7SUFDN0IsMkNBQXlCLENBQUE7SUFDekIsK0NBQTZCLENBQUE7SUFDN0IsK0NBQTZCLENBQUE7SUFDN0IsMkNBQXlCLENBQUE7SUFFekIsMkNBQXlCLENBQUE7SUFDekIsbURBQWlDLENBQUE7SUFFakMsNERBQTBDLENBQUE7SUFDMUMsd0RBQXNDLENBQUE7SUFDdEMsNERBQTBDLENBQUE7SUFDMUMsNERBQTBDLENBQUE7SUFDMUMsd0RBQXNDLENBQUE7SUFDdEMsNERBQTBDLENBQUE7SUFFMUMsMkRBQXlDLENBQUE7QUFDM0MsQ0FBQyxFQWxFVyxjQUFjLEdBQWQsc0JBQWMsS0FBZCxzQkFBYyxRQWtFekIifQ==